<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7R7Ak3/tc-custom/9781488002663.jpg?1708747996737" alt="This image is the cover for the book Her Texas Rescue Doctor, Texas Rescue"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Her Texas Rescue Doctor, Texas Rescue
      </h1>
      <p class="bookDescription body article font2">
        <p>Spin doctor meets ER doctor <br/><br/>Living in her Hollywood movie star sister's shadow is hard enough! But as her personal assistant, Grace Jackson is continually repairing the swath of damage the diva leaves in her wake. And now her antics have landed her in the Texas Rescue ER! What Grace needs is to find her sister the perfect mansomeone to dispel the rumor mill. Satisfy the paparazzi. But where could she find this superhero wannabe? <br/><br/>Enter ER doctor Alex Gregory: he's dignified, giftedand a bit of a nerd. Still, he has an eye for genuine people like lovely Grace. So he reluctantly agrees to let Grace make him over and help salvage her sister's reputation. From geek to chic, Alex becomes a dazzling escort for a celebrity-studded charity ball. But Grace has to wonder: did she remake Alex for her sisteror herself?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Caro Carson
      </h2>
      
      <p class="authorDescription body article">Despite a no-nonsense background as a West Point graduate,&#160;Army officer, and Fortune 100 sales executive, Caro Carson has always treasured the happily-ever-after of a&#160;good romance novel.&#160;As&#160;a Rita-winning Harlequin author, Caro is delighted to be living her own happily-ever-after with her husband and children in&#160;Florida, a location which has saved the coaster-loving theme park fanatic a fortune on plane tickets.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?02206149